import { inject, Injectable } from '@angular/core';
import { CalendarService, ProductTimeSlotDTO, SpaSimpleProductDTO } from '@api';
import { Observable } from 'rxjs';
import { DateTime } from 'luxon';
import '@utils/date-time.utils';

@Injectable({
  providedIn: 'root',
})
export class AvailableSlotsService {
  private readonly calendarService = inject(CalendarService);

  public getAvailableSlots(
    simpleProduct: SpaSimpleProductDTO,
    from: DateTime,
    excludedItemIds: string[],
  ): Observable<ProductTimeSlotDTO[]> {
    const now = DateTime.now().set({ second: 0 });
    const nextPossibleTimeFromNow = DateTime.max(from, now);

    return this.calendarService.getAvailableSlots(
      simpleProduct.productId,
      nextPossibleTimeFromNow.toLocalDateTime(),
      excludedItemIds,
    );
  }
}
